export type CurrencyCode = "EUR" | "USD" | "GBP";

export const currencyCodes: readonly CurrencyCode[] = ["EUR", "USD", "GBP"];
